import { render } from "./VerifyCodeModal.vue?vue&type=template&id=0873dcce&scoped=true"
import script from "./VerifyCodeModal.vue?vue&type=script&lang=js"
export * from "./VerifyCodeModal.vue?vue&type=script&lang=js"

import "./VerifyCodeModal.vue?vue&type=style&index=0&id=0873dcce&lang=scss&scoped=true"

import exportComponent from "/usr/src/app/vue-code/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0873dcce"]])

export default __exports__